import { Box } from '@mui/material';
import { useMemo, ReactNode } from 'react';
import { ItemWithId } from 'components/HMRC/data/types';
import { TEmManagementByIdFullResponse } from 'redux/reducers/emManagement/types';
import { TBoxesStructureItem } from '../emBoxesStructure';
import { EasParamsBox } from '../EasParamsBox';
import { TBoxStructure } from '../EasParamsBox/types';

type TProps = {
	boxesStructure: TBoxesStructureItem[];
};

export const EMManagementIdBody = ({ boxesStructure }: TProps) => {
	const sectionA = useMemo(
		() => boxesStructure.filter((item) => item.section === 'A' && item.show),
		[boxesStructure],
	);
	const sectionB = useMemo(
		() => boxesStructure.filter((item) => item.section === 'B' && item.show),
		[boxesStructure],
	);
	const sectionC = useMemo(
		() => boxesStructure.filter((item) => item.section === 'C' && item.show),
		[boxesStructure],
	);

	const renderBox = (item: TBoxesStructureItem) => {
		let content: ReactNode = null;
		if (item.component) {
			const Component = item.component;
			content = <Component key={item.id} data={item.data} />;
		} else if (item.structure) {
			content = (
				<EasParamsBox
					key={item.id}
					link={item.link}
					items={(item.data ?? {}) as ItemWithId}
					boxStructure={item.structure as TBoxStructure<ItemWithId | TEmManagementByIdFullResponse>}
					columnNumber={item.columnNumber}
					editable={item.editable}
					loading={item.loading}
					minHeight={item.minHeight}
					fontSize="s"
					editDialog={item.editDialog ?? null}
					// showCloseButton={true}
				/>
			);
		}
		if (!content) return null;
		const isSectionA = item.section === 'A';
		return (
			<Box
				key={item.id}
				id={`em-widget-${item.id}`}
				sx={{
					width: '100%',
					minWidth: 0,
					...(isSectionA && {
						display: 'flex',
						flexDirection: 'column',
						'& > *': { flex: 1, minHeight: 0 },
					}),
				}}
			>
				{content}
			</Box>
		);
	};

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pl: 1, pr: 1, pt: 0.5 }}>
			<Box
				id="em-management-body-sectionA"
				sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}
			>
				{sectionA.map(renderBox)}
			</Box>

			<Box
				id="em-management-body-containerBC"
				sx={{ display: 'flex', flexDirection: 'row', gap: 1.5, width: '100%', flex: '3 1 auto' }}
			>
				<Box
					id="em-management-body-sectionB"
					sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 2, minWidth: 0 }}
				>
					{sectionB.map(renderBox)}
				</Box>
				<Box
					id="em-management-body-sectionC"
					sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1, minWidth: 0 }}
				>
					{sectionC.map(renderBox)}
				</Box>
			</Box>
		</Box>
	);
};
